import(/* webpackMode: "eager" */ "/opt/render/project/src/apps/storefront/app/global-error.tsx");
